module.exports = __webpack_public_path__ + "static/mainBG-2545a5da8a52dbc0b25f205fcc394af0.jpeg";